// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import infiniteScroll from "./infiniteScroll";
import toc from "./toc";
import continueReading from "./continueReading";
import footnotes from "./footnotes";
import feedNotes from "./feedNotes";
import lightbox from "./lightbox";
import plate from "./plate";
import hatnote from "./hatnote";
import looseContent from "./looseContent";


// Fix up the post body first, before anything paints much and before the
// TOC/footnote scripts read it: wrap loose HTML-card text in <p>, then
// mark an italic opening hatnote (which may be one of those new <p>s)
looseContent();
hatnote();

// Call the infinite scroll, table-of-contents,
// continue-reading, footnotes and feed-excerpt functions
infiniteScroll();
toc();
continueReading();
footnotes();
feedNotes();
lightbox();
plate();
